import { audio } from '@/audio-singleton';
import { gameSignals } from '@/bridge/gameSignals';
import { t } from '@/i18n';
import { SHOTS_PER_DAY } from '@/lib/constants';
import { SOUND_UI_ENABLED } from '@/lib/features';
import { CogIcon } from './icons';
import { MuteToggle } from './MuteToggle';

export interface HeaderProps {
  onOpenSettings: () => void;
  rightSlot?: preact.ComponentChildren;
}

export function Header({ onOpenSettings, rightSlot }: HeaderProps) {
  const scene = gameSignals.currentScene.value;
  const num = gameSignals.puzzleNumber.value;
  // shotIndex tracks both daily and practice rounds; `record` stays frozen on
  // the daily round during practice (practice shots go to practiceRecord).
  const shotsTaken = gameSignals.shotIndex.value;
  const shotN = Math.min(shotsTaken + 1, SHOTS_PER_DAY);

  return (
    <header
      class="fixed top-0 inset-x-0 z-30 pointer-events-auto bg-bg/85 backdrop-blur-md border-b border-foil/15 text-text pt-[env(safe-area-inset-top)]"
      role="banner"
    >
      <div class="h-11 flex items-center justify-between px-4">
        <div class="flex items-baseline gap-2.5">
          <span class="font-display text-base text-text">
            {t('header.brand')}
          </span>
          {num !== null && num > 0 && (
            <span class="font-mono text-[10px] uppercase tracking-[0.22em] text-foil">
              #{num}
            </span>
          )}
        </div>
        {scene === 'PLAY' && (
          <span class="font-mono text-xs tracking-wider text-text-2">
            {t('header.shotProgress', { n: shotN, total: SHOTS_PER_DAY })}
          </span>
        )}
        <div class="flex items-center gap-1">
          {rightSlot}
          {SOUND_UI_ENABLED && <MuteToggle />}
          <button
            type="button"
            class="p-2 -mr-1 rounded-full text-text-2 hover:text-text hover:bg-text/5 active:bg-text/10 transition-colors"
            aria-label={t('header.openSettings')}
            onClick={() => { audio().play('tap'); onOpenSettings(); }}
          ><CogIcon size={20} /></button>
        </div>
      </div>
    </header>
  );
}
